import type { PostBotPipeline } from '../../lib/api-client.js';

/** Retry times are eligibility times, not completion promises. */
export function pipelineStatus(p:PostBotPipeline|null|undefined, now=Date.now()) {
  if(!p || p.stage==='complete' || p.stage==='paused')return null;
  if(p.stage==='blocked')return {label:'Refresh needs attention',detail:'Automatic setup retries stopped.'};
  if(p.stage==='queued')return {label:'Refresh queued',detail:'Waiting for its turn to refresh.'};
  if(p.stage==='loading_media')return {label:'Loading folders',detail:'Loading and validating folder media.'};
  if(p.stage==='planning')return {label:'Preparing schedule',detail:'Creating upcoming posts from the refreshed folders.'};
  const cooling=p.error==='cloudflare_backoff';
  const future=!!p.nextRetryAt && Date.parse(p.nextRetryAt)>now;
  const when=future?new Date(p.nextRetryAt!).toLocaleTimeString('en-GB',{timeZone:'Europe/Berlin',hour:'2-digit',minute:'2-digit'}):null;
  return {label:future?(cooling?'Cloudflare cooldown':'Waiting to retry'):'Refresh queued',
    detail:future?`Retry eligible after ${when} (Europe/Berlin). ${cooling?'Further Cloudflare blocks can extend the wait.':'The refresh starts after earlier queued work.'}`
      :`Waiting for its turn to refresh.${cooling?' Cloudflare cooldown will be checked again before loading.':''}`};
}

export function rosterPostingStatus(row:{configured:boolean;paused:boolean;status:string;pipeline?:PostBotPipeline|null}) {
  if(!row.configured)return 'Not configured';
  if(row.paused)return 'Posting paused';
  return pipelineStatus(row.pipeline)?.label ?? row.status.replaceAll('_',' ');
}
